<h2 mat-dialog-title>{{isEditing ? 'Edit' : 'Create'}} Folder</h2>
<mat-dialog-content>
  <form [formGroup]="newFolderForm">
    <mat-form-field appearance="fill" style="width:100%">
      <mat-label>Folder Name</mat-label>
      <input matInput placeholder="Enter a folder name" formControlName="folderName" />
      <mat-error *ngIf="newFolderForm.controls['folderName'].invalid && (newFolderForm.controls['folderName'].touched || newFolderForm.controls['folderName'].dirty)">
        <p *ngIf="newFolderForm.controls['folderName'].errors.required">Folder name is <strong>required</strong></p>
        <p *ngIf="newFolderForm.controls['folderName'].errors.maxlength">Folder name can not exceed <strong>256</strong> characters.</p>
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" id="submitAddEditFolderForm" [disabled]="!newFolderForm.valid" (click)="save()">Save Folder</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
